import { LoggedInQuery } from '../../../../generated/gql';
import { useIntegratedQuery } from '../../../../hooks/useIntegratedQuery';
import LOGGED_IN from '../../graphql/loggedIn';

export const useLoggedIn = (authenticated: boolean) => {
  return useIntegratedQuery<LoggedInQuery>(LOGGED_IN, 'community', {
    fetchPolicy: 'cache-first',
    skip: !authenticated,
  });
};
